
<validation-observer v-slot="{ invalid }" slim>
  <div v-if="loading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="loader"></div>
  </div>

  <div class="w-full flex justify-center bg-[#f9f8f6] pt-[48px]">
    <div class="head-container max-w-[1216px]">
      <div v-if="lead && (quote || lead.id)" class="cart-container flex justify-center 1170-bp:justify-between">
        <div class="w-full max-w-[720px]">
          <div class="w-full card">
            <div  class="mb-5 flex flex-col gap-5">
              <!-- CONTAINER SPECIFICATIONS -->
              <!-- Do not allow changes if it's shipping -->
              <p class="cart-card-title">Container Specifications</p>
              <div class="flex flex-col 1170-bp:flex-row gap-5">
                <div class="w-full" v-if="lead.data && lead.data.useCase != 'shipping'">
                  <label class="cart-card-label">Type</label>
                  <div class="select is-fullwidth mt-1">
                    <select @change="applyFilter()" v-model="updates.purchaseType" class="custom-select">
                      <option value="rental">Renting</option>
                      <option value="sale">Buying</option>
                    </select>
                  </div>
                </div>
                <div class="w-full">
                  <label class="cart-card-label">Length</label>
                  <div class="select is-fullwidth mt-1">
                    <select @change="applyFilter()" v-model="updates.size" class="custom-select">
                    <option :value="value" v-for="(label, value) in availableSizes" :key="value">{{label}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex flex-col 1170-bp:flex-row gap-5">
                <div class="w-full" v-if="updates.purchaseType == 'sale'">
                  <label class="cart-card-label">Condition</label>
                  <div class="select is-fullwidth mt-1">
                    <select @change="applyFilter()" v-model="updates.condition" class="custom-select">
                      <option v-for="(label, value) in conditions" :value="value" :key="value">{{label}}</option>
                    </select>
                  </div>
                </div>
                <div class="w-full">
                  <label class="cart-card-label">Door Config</label>
                  <div class="select is-fullwidth mt-1">
                    <select @change="applyFilter()" v-model="updates.door" class="custom-select">
                      <option :value="value" v-for="(label, value) in doorConfiguration" :key="value">{{label}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="w-full">
                <label class="cart-card-label">Height</label>
                <div class="select is-fullwidth mt-1">
                  <select @change="applyFilter()" v-model="updates.height" class="custom-select">
                    <option value="any">Any</option>
                    <option value="standard">8'6</option>
                    <option value="HC">9'6</option>
                  </select>
                </div>
              </div>
            </div>

            <section>
              <!-- QUOTE ITEMS SELECTED -->
              <article class="product-option container-item" v-for="priceBookEntry in currentPriceBooks" :key="priceBookEntry.id">
                <product-details :price-book-entry="priceBookEntry"></product-details>
              </article>
              <p v-if="!currentPriceBooks.length" class="mt-5">
                Currently we have no products available for the selected options - <a href="/contact">Contact Us</a>
              </p>
            </section>
          </div>

          <div v-if="(personalInfoVisible || orderInfoVisible) || (showPrice && orderInfoVisible)" :class="personalInfoVisible || orderInfoVisible ? 'mt-5' : ''">
            <div class="card checkout-form checkout-form-container">
              <personal-info-form :showPrice="showPrice" ref="personalInfoForm" v-if="personalInfoVisible || orderInfoVisible"/> 
            </div>
            <div class="card checkout-form checkout-form-container" v-if="showPrice && orderInfoVisible">
              <checkout-form ref="checkoutForm"/>
            </div>
          </div>
          <div v-if="quote && quote.items.length > 0" class="w-full max-w-[448px] 1170-bp:hidden">
            <!-- QUOTE ITEMS SUMMARY (Mobile bottom of screen)-->
            <div class="card">
              <quote-items />
              <quote-totals />
            </div>
            <!-- RECOMENDED PRODUCTS -->
            <div class="card" v-if="quote && getRecommendedProductInPricebooks(currentPriceBooks).length > 0">
              <section class="product-list recommended-products">
                <span class="recomended-product-title mb-4">Other solutions you may like</span>
                <div class="product-option mt-5" v-for="recommended in getRecommendedProductInPricebooks(currentPriceBooks)" :key="recommended.id">
                  <recommended-products :price-book-entry="recommended"></recommended-products>
                </div>
              </section>
            </div>
          </div>
          <!-- BOTTOM BUTTONS -->
          <div class="button-container ">
            <div v-if="showPrice" class="flex justify-between items-center">
              <div
                v-if="!orderInfoVisible"
                class="is-halfwidth"
              >
                <button
                  @click="requestQuote"
                  class="email-request-quote-btn flex justify-center items-center"
                  :class="[loading ? 'is-loading' : '', personalInfoVisible ? 'action-button' : 'close-button']"
                  :disabled="personalInfoVisible && (loading || invalid || (quote && !quote.items.length) || !quote)"
    
                >
                  <p>{{personalInfoVisible ? 'Send Quote' : 'Email Quote'}}</p>
                </button>
              </div>
              <div
                v-if="!personalInfoVisible"
                class="level-item is-halfwidth"
              >
                <button
                    @click="reserveOrder" 
                    class="confirm-reserve-order-btn transition-all flex justify-center items-center"
                    :disabled="(loading || invalid || (quote && !quote.items.length) || !quote)"
                    :class="{ 'is-loading': loading }"
                  >
                  <p>{{orderInfoVisible ? 'Confirm Order' : 'Reserve Order'}}</p>
                </button>
              </div>
              <div
                v-if="personalInfoVisible || orderInfoVisible"
                class="level-item is-halfwidth"
              >
                <button
                    @click="cancel"
                    class="close-button email-request-quote-btn flex justify-center items-center"
                  >
                    <p>Cancel</p>
                </button>
              </div>
            </div>
            <div v-if="!showPrice">
              <div class="level-item is-fullwidth">
                <button
                  @click="requestQuote"
                  class="email-request-quote-btn transition-all flex justify-center items-center"
                  :disabled="loading || invalid || (quote && !quote.items.length) || !quote"
                  :class="{ 'is-loading': loading }"
                >
                  <p>{{personalInfoVisible ? 'Email Quote' : 'Request Quote'}}</p>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="quote && quote.items.length > 0" class="w-full max-w-[448px] hidden 1170-bp:inline">
          <!-- QUOTE ITEMS SUMMARY (left side)-->
          <div class="card">
            <quote-items />
            <quote-totals />
          </div>
          <!-- RECOMENDED PRODUCTS -->
          <div class="card" v-if="quote && getRecommendedProductInPricebooks(currentPriceBooks).length > 0">
            <section class="product-list recommended-products">
              <span class="recomended-product-title mb-4">Other solutions you may like</span>
              <div class="product-option mt-5" v-for="recommended in getRecommendedProductInPricebooks(currentPriceBooks)" :key="recommended.id">
                <recommended-products :price-book-entry="recommended"></recommended-products>
              </div>
            </section>
          </div>
        </div>

        <!-- MOBILE SUMMARY COMPONENT -->
        <div class="mobile-bottom-component" :class="{ 'is-expanded': isExpanded }">
          <div class="component-header">
            <span>Summary</span>
            <button @click="toggleExpand">
              <img src="@/images/quote-builder/drag_indicator.svg" alt="Toggle quote summary">
            </button>
          </div>
          <div class="component-content" v-if="isExpanded">
            <quote-items :hideTitle="true" />
            <quote-totals />
          </div>
        </div>

      </div>
    </div>
  </div>
  <div v-if="!lead || !lead.id" class="w-full flex justify-center items-center bg-[#f9f8f6] pb-[64px] font-rubik"> 
    <div class="empty-cart-container w-full flex flex-col gap-10 justify-center items-center max-w-[1216px] border-none lg:border-[#EDE9E3] lg:rounded-2xl lg:border lg:bg-[#EDE9E3] lg:h-[280px] pb-[48px] lg:pb-0">
      <p class="empty-cart-container-p">Your cart is empty</p>
      <button @click="browseProducts()" class="empty-cart-container-btn">
        <p>Browse products</p>
      </button>
    </div> 
  </div> 
  <div v-if="thankYouModalVisible">
    <thanks :closeModal="closeModal" :type="actionType" :closedQuote="closedQuote" :paymentLink="paymentLink"/>
  </div>
</validation-observer>
